<template>
  <div>
    <el-dialog
      top="6vh"
      width="310px"
      center
      title="关闭收款"
      :visible="paymentModeObj.visible"
      @close="HandleCancel()"
    >
      <el-form label-width="150px">
        <el-form-item label="只付款不收款模式：">
          <el-switch
            @change="toggleStatus($event)"
            v-model="isWithdrawOnly"
            :active-value="true"
            :inactive-value="false"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          {{ isWithdrawOnly ? "启用" : "停用" }}
        </el-form-item>
      </el-form>
      <div
        v-if="['sms_admin'].indexOf(userInfo.userType) === -1"
        style="text-align: right"
      >
        <el-button size="small" @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          size="small"
          type="success"
          @click="HandleSubmit()"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { updatePaymentMode } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["paymentModeObj"],
  data() {
    return {
      submitLoading: false,
      isWithdrawOnly: false,
    };
  },
  watch: {
    paymentModeObj(row) {
      if (row.visible) {
        this.isWithdrawOnly = row.isWithdrawOnly;
      }
    },
  },
  methods: {
    HandleCancel() {
      this.isWithdrawOnly = false;
      this.$emit("update:payment-mode-obj", {});
    },
    toggleStatus($event) {
      this.isWithdrawOnly = $event;
    },
    HandleSubmit() {
      this.submitLoading = true;
      updatePaymentMode(this.paymentModeObj.id, {
        isWithdrawOnly: this.isWithdrawOnly,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleCancel();
          this.$emit("HandleGetList");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-notification {
  font-size: 16px;
  line-height: 40px;
  .text-number-red {
    color: #ff0000;
    font-size: 22px;
  }
  .text-number-blue {
    color: #0000ff;
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/PaymentModeDialog.vue